// extracted by mini-css-extract-plugin
export var hidden = "_q5-1";
export var visible = "_q5-0";